import React from "react";
interface Props {
  error?: string | null;
  onClick: () => void;
}
const AddToCartButton = ({
  error,
  onClick
}: Props) => {
  return <>
      <button className="btn btn-cart" type="button" onClick={onClick}>
        Add to Cart
      </button>
      <div aria-live="polite">
        {error && <div id="sh-quantity-error" className="alert alert-danger z-10">
            <i aria-hidden="true" className="icon-attention" />
            {error}
          </div>}
      </div>
    </>;
};
export default AddToCartButton;